module.exports = __webpack_public_path__ + "static/017-893bff266f4777ea4d6f6da1af40b938.jpg";